// extracted by mini-css-extract-plugin
export var productImage = "_y9-0";